import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
}

const SEO = ({
  title,
  description = 'Consumer Cloud Services provide email and consumer data management solutions across all channels for your data-driven marketing needs.',
  canonical,
  ogImage = '/assets/optimized/Logo-removebg-preview-1920.jpg',
  ogType = 'website',
}: SEOProps) => {
  const siteUrl = 'https://consumercloudservices.co.uk/';

  return (
    <Helmet>
      {/* Basic */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      {canonical && <meta property="og:url" content={`${siteUrl}${canonical}`} />}
        <meta name="google-site-verification" content="DshcnxCrPcFj7lChgVN7NQw08OAxFQi--P8mOY2cJdU" />
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
      <link rel="icon" type="image/x-icon" href="/favicon.ico"></link>
    </Helmet>
  );
};

export default SEO;